import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcoReserved = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 36,
	height: 36,
	fill: "none",
	viewBox: "0 0 36 36",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M23 16v-4a5 5 0 0 0-10 0v4zM18 5a7 7 0 0 0-7 7v6h14v-6a7 7 0 0 0-7-7",
		clipRule: "evenodd"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M24.661 18H11.34c-.702 0-1.073.037-1.29.078a1.2 1.2 0 0 0-.385.137c-.206.108-.35.252-.454.445a1.1 1.1 0 0 0-.132.36c-.04.205-.078.565-.078 1.253v6.454c0 .688.038 1.048.078 1.253.03.156.064.236.132.36.104.193.248.337.454.445.13.069.217.104.386.137.216.04.587.078 1.289.078h13.32c.702 0 1.073-.037 1.29-.078.168-.033.255-.068.386-.137.204-.108.349-.252.453-.445.068-.124.101-.204.132-.36.04-.205.078-.565.078-1.253v-6.454c0-.688-.038-1.048-.078-1.253a1.1 1.1 0 0 0-.132-.36 1.05 1.05 0 0 0-.453-.445 1.2 1.2 0 0 0-.387-.137c-.216-.04-.587-.078-1.289-.078m0-2H11.34c-1.509 0-2.056.155-2.608.445-.551.29-.984.717-1.279 1.26C7.157 18.25 7 18.787 7 20.273v6.454c0 1.486.157 2.024.452 2.568.295.543.728.97 1.28 1.26.551.29 1.098.445 2.607.445H24.66c1.509 0 2.056-.155 2.607-.445s.985-.717 1.28-1.26c.295-.544.452-1.082.452-2.568v-6.454c0-1.486-.157-2.024-.452-2.568a3.05 3.05 0 0 0-1.28-1.26c-.551-.29-1.098-.445-2.607-.445",
		clipRule: "evenodd"
	})]
});
export default SvgIcoReserved;
